import Divider from '@mui/material/Divider';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';
import SearchDistance from '../util/SearchDistance';
import ProgramLocation from './ProgramLocation';
import { motion } from 'framer-motion'
import { convertToPlain, truncateText } from 'app/shared-components/utils'
import { useSelector } from 'react-redux';
import { createElement } from 'react';

 

const container = {
    show: {
      transition: {
        staggerChildren: 0.05,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };

function parseProgramId(idString){
	const start= idString.indexOf(':');
	const end= idString.indexOf('!');
	return idString.substring(start + 1, end);
}

function generateLink(program, isSearch, isPublic, organizationUniqueName){
    const id=  isSearch ? parseProgramId(program.id) : program.id;
    let link= isPublic ? "/public" : "";
    if (organizationUniqueName) link= link + "/organization/" + organizationUniqueName;
    else if (program.organizationUniqueName) link= link + "/organization/" + program.organizationUniqueName;
    link= link + "/program/" + id;
    return link;
}

function ProgramListItem({ program, isSearch, isPublic, noLink, menu, organizationUniqueName, basePath }) {
  const name= isSearch ? (program.programName + " (" + program.organizationName + ")") : program.name;
  const link = basePath ? basePath + program.id : noLink ? "" : generateLink(program, isSearch, isPublic, organizationUniqueName);
  const plainAbout= truncateText(convertToPlain(program?.description), 200);
  const useDistance= isSearch && program.distance;

  if (!program) return null;
  
  return (

      <Card component={motion.div} variants={item} key={program.id}  className="mb-10 flex flex-col h-full relative">

          {/* Menu moved outside CardActionArea */}
          {menu && (
              <div className="absolute top-6 right-6 z-10" onClick={(e) => e.stopPropagation()}>
                  {createElement(menu, {program: program})}
              </div>
          )}
          <CardActionArea disabled={noLink} component={NavLinkAdapter} to={link} className="flex flex-col items-start align-start h-full">
          <CardHeader
            className="px-24 pt-20 pb-5"
            title={<Typography color="secondary">{name}</Typography>}
            subheader={<div> <ProgramLocation program={program}/>
                             {useDistance && <SearchDistance distance={program.distance} /> }
                       </div>}
          />

          <CardContent className="px-20 pt-0 h-full w-full flex flex-col">
    
           {program.description && (
			  <>
              <Divider style={{width:'100%', margin:'5px'}} />
              <Typography
                className="inline"
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{
				  width:'100%',
			      overflow: 'hidden',
			      textOverflow: 'ellipsis',
			      display: '-webkit-box',
			      WebkitLineClamp: '3',
			      WebkitBoxOrient: 'vertical',
			    }}
              >
                 {plainAbout}
              </Typography>
              </>
              )}
              
              {!!program.specializations && program.specializations.length > 0  && (
			  <>
			  <Divider style={{width:'100%', margin:'5px'}} />
              <Typography
                display="block"
                variant="body2"
                color="text.secondary"
                sx={{
				  width:'100%',
			      overflow: 'hidden',
			      textOverflow: 'ellipsis',
			      display: '-webkit-box',
			      WebkitLineClamp: '2',
			      WebkitBoxOrient: 'vertical',
			    }}
              >
                 Treatment Areas: {program.specializations.join()}
              </Typography>
              </>
            )}

          </CardContent>
      
		 </CardActionArea>
		</Card>
    
  );
}


export default ProgramListItem;
